import TablistView from './tablistView.factory.js';
var _tablistViewPropsManager = function tablistViewPropsManager(ins) {
  var className = ins.getSetting('tablistViewClass') + ' ' + ins.getSetting(ins.getOption('direction') + "Class");
  if (ins.getOption('isVertical')) {
    className += ' ' + ins.getSetting('verticalClass');
  }
  var themeName = ins.getOption('theme');
  if (themeName) {
    className += ' ' + themeName;
  }
  var tablistStyle = ins.getOption('tablistStyle') || {};
  var result = {
    className: className
  };
  if (typeof tablistStyle === 'object') {
    result.style = tablistStyle;
  }
  return result;
};
export { _tablistViewPropsManager as tablistViewPropsManager };
export default TablistView.bind(undefined, function (ins) {
  return {
    tablistViewPropsManager: function tablistViewPropsManager() {
      return _tablistViewPropsManager(ins);
    }
  };
});